import { type NextBestAction } from '@post-office/confluence-next-best-action';
import {
	type BackendPlacementMessage,
	type FrontendPlacementMessage,
} from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { CreateWithRovo } from './components/create-with-rovo';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';
import type {
	CreatePlacementMessageConfig,
	AnyPayload,
} from '@post-office/message-template-contracts/placement-v2';
import {
	type BackendSyncMessageStage,
	type AnyBackendMessageStage,
	type AnyFrontendStage,
} from '@post-office/placement-common-v2/create-placement/types';
import {
	RovoCcpId,
	type TransformMetadataResult,
} from '@post-office/shared-contracts/message-template-metadata';

export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: assertMessageTemplateContext,
		stage: () => ({
			rerankingMetadata: { productId: RovoCcpId },
		}),
	},
}));

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
};

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({
			nextBestActionType,
			handleOnDismissed,
			onSideNavClick,
		}: MessageFrontendProps) => {
			return (
				<CreateWithRovo
					action={nextBestActionType}
					onPrimaryActionClick={onSideNavClick}
					onDismissClick={handleOnDismissed}
				/>
			);
		},
	},
});
